import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { useTranslation, Trans } from 'react-i18next';
import { RootState } from '../../store/rootReducer'
import { analyze, clearError } from '../signing/ovscSlice'
import { UploadAndErrors} from '../upload/UploadAndErrors'
import ContentLayout  from '../layout/ContentLayout'
import { setFiles, reset} from '../upload/dropZoneSlice'


import './index.css';
import "react-client-captcha/dist/index.css"
//import ReactDOM from "react-dom";


const Home:React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
 
  
  
  const { inSignCall, errorResult } = useSelector(
    (state: RootState) => state.ovsc, shallowEqual
  )
  const { files } =   useSelector((state: RootState) => state.dropZone) 
  let dimmerText:string=""
  
  

  if (inSignCall)
  {
    dimmerText=t("analyze.wait")
  }
  
  return <ContentLayout>
    
    <div><Trans i18nKey="analyze.description"></Trans></div>
    <p></p>
    <UploadAndErrors inputFiles={files} 
      onChange={ (f) => { dispatch(setFiles(f)); dispatch(clearError()) } }
      uploadButtonCaption={t("analyze.upload")}  
      cancelButtonCaption={t("analyze.cancel")} 
      handleReset={ () => {
        dispatch(reset()); 
        dispatch(clearError());}
      }
      errorResult = {errorResult}
      handleUpload={() => {dispatch(clearError()); dispatch(analyze(files[0])) }}
      dimmerText={dimmerText} />
      
  </ContentLayout>

}

export default Home;


